import axios from "../../api/hbscan";
import ICleaningSchedule from "../../models/cleaningSchedule";
import AuthService from "../auth/AuthService";

class CleaningScheduleService {
    GetCleaningScheduleByLocalId = async (localId: number) => {
        const URI = "/api/hbscan/CleaningSchedule/GetCleaningScheduleByLocal";
        return (
            await axios.get<ICleaningSchedule>(URI, {
                headers: { Authorization: AuthService.guid },
                params: { localId },
            })
        ).data;
    };

    async GetCleaningSchedules(
        localIds: number[]
    ): Promise<ICleaningSchedule[]> {
        const url = `/api/hbscan/CleaningSchedule/GetCleaningSchedules`;
        const req = await axios.post<ICleaningSchedule[]>(url, localIds,
            {
                headers: {
                    Authorization: AuthService.guid,
                    "Content-Type": "application/json",
                },
            })


        return req.data || [];
    }

    PostCleaningSchedule = async (localCleaning: ICleaningSchedule) => {
        const URI = "/api/hbscan/CleaningSchedule/PostCleaningSchedule";
        return (
            await axios.post<number>(URI, JSON.stringify(localCleaning), {
                headers: { Authorization: AuthService.guid },
            })
        ).data;
    };

    PutCleaningSchedule = async (localCleaning: ICleaningSchedule) => {
        const URI = "/api/hbscan/CleaningSchedule/PutCleaningSchedule";
        await axios.put(URI, JSON.stringify(localCleaning), {
            headers: { Authorization: AuthService.guid },
        });
    };
}
export default new CleaningScheduleService();
